var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.windowWidth < 440)?_c('div',{attrs:{"id":"mobile-search"}},[_c('Search')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }